export enum DocumentStatus {
  DRAFT = 'draft',
  IN_PROGRESS = 'in-progress',
  SIGNED = 'signed',
  WITHDRAWN = 'withdrawn',
  REJECTED = 'rejected'
}
